export enum PositionSubscriptionType {
  Candidate = 'candidate',
  Referral = 'referral',
}

export enum PositionSubscriptionFrequency {
  Every3Days = 'every_3_days',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

export const PositionSubscriptionFrequencyOptions = [
  { label: 'Every 3 days', value: PositionSubscriptionFrequency.Every3Days },
  { label: 'Weekly', value: PositionSubscriptionFrequency.Weekly },
  { label: 'Monthly', value: PositionSubscriptionFrequency.Monthly },
];

export const PositionSubscriptionCountries: string[] = [
  'Argentina',
  'Brazil',
  'Bulgaria',
  'Canada',
  'Colombia',
  'Costa Rica',
  'Guatemala',
  'India',
  'Mexico',
  'Peru',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'USA',
  'Ukraine',
  'United Kingdom',
  'Venezuela',
];
export const PositionSubscriptionTechnicalFlows: string[] = [
  '.NET',
  'AQA',
  'AQA C Sharp',
  'AQA Java',
  'AQA Java/Python',
  'AQA JavaScript',
  'AQA Python',
  'AQA Selenium',
  'AWS',
  'Android',
  'Angular',
  'Apache Spark',
  'C Sharp',
  'C++',
  'Data Analyst',
  'Data Engineer',
  'Data Engineer Java',
  'Data Engineer Python',
  'Data Engineer SQL',
  'Data Engineer Scala',
  'Data Scientist',
  'Data Scientist Analysis',
  'Data Scientist Generative AI',
  'Data Scientist Machine Learning',
  'Data Specialist',
  'Database Administrator',
  'DevOps',
  'DevOps AWS',
  'DevOps Azure',
  'Developer',
  'Elixir',
  'Flutter',
  'GCP',
  'Golang',
  'Java',
  'JavaScript',
  'Kotlin',
  'Machine Learning',
  'Node.js',
  'Perl',
  'PHP',
  'Python',
  'Python/React.js',
  'QA',
  'React Native',
  'React.js',
  'Ruby',
  'Rust',
  'SDET',
  'SQL',
  'Salesforce',
  'Scala',
  'ServiceNow',
  'Shopify',
  'Spark Java',
  'Swift',
  'System/Security Engineer',
  'TechOps',
  'Typescript',
  'UI/UX Design',
  'UI/UX Designer',
  'UX Researcher',
  'Unity',
  'Vue.js',
  'XSLT',
  'iOS',

  // Non-engineering values after
  'Account Manager',
  'Accountant',
  'Admin Staff',
  'Business Analyst',
  'Business Development Manager',
  'C-level Management',
  'CISO',
  'Client Partners',
  'Copywriter',
  'Delivery Manager',
  'Email Marketing Specialist',
  'Event Manager',
  'Executive Assistant',
  'Finance',
  'HR Assistant',
  'HR Specialist',
  'Human Resources',
  'IT Support Engineer',
  'IT support',
  'Information Security Specialist',
  'Internal Analyst',
  'Legal',
  'Marketing',
  'Marketing Specialist',
  'Marketing manager',
  'Operations',
  'Operations Manager',
  'People Partner',
  'Product Manager',
  'Product Owner',
  'Program Manager',
  'Project Manager',
  'Recruiting',
  'Sales',
  'Sales Development Representative',
  'Scrum Master',
  'Support',
  'Talent Operations',
  'Travel Manager',
];

export const PositionSubscriptionCandidateUnsubscribeReasons: string[] = [
  'I’m not looking for a job right now',
  'I’ve already found a new job',
  'I get too many emails',
  'These jobs aren’t a good fit for me',
  'I prefer checking other platforms',
  'I just want to take a break from emails',
];

export const PositionSubscriptionReferrerUnsubscribeReasons: string[] = [
  'I’m not referring anyone right now',
  'I don’t want to receive these emails anymore',
  'I get too many emails',
  'I prefer to look for positions on my own',
];
